import graphql__cde694468780d29cfb12 from "./__generated__/PageSectionMap_pageSection.graphql.js";import { graphql, useFragment } from "react-relay";
import { defineMessages } from "react-intl";

import MapBase from "../Maps/MapBase";
import ButtonLink from "../Buttons/ButtonLink";
import PageSectionBlockWithTitleAndDescription from "./PageSectionBlockWithTitleAndDescription";
import ContributionsMapContributionsMarkersManager from "../ParticipativeModule/Visualizations/ContributionsMap/ContributionsMapContributionsMarkersManager";
import { useFormatMessage } from "../Intl/Context";
import { isAuthorized } from "../Utils/authorizations";
import MapContextProvider, { useMapContext, useMapType } from "../Maps/MapContext";
import MapUsersPointsManager from "../Maps/UsersMap/MapUsersPointsManager";

const PageSectionMapInner = props => {
  const { title, description, map, mapHeight, zoomDefault } = props.pageSection;
  const { slug, participativeModule } = map;
  const { contributionsDisplayAuthorized } = participativeModule?.authorizations || {};

  const { mapPath } = useMapContext();
  // Define whether the displayed map is a contributions or users map, to display the
  // right data markers in addition to other informative markers
  const { isContributionsMap, isUsersMap } = useMapType();

  const t = useFormatMessage();
  const seeMapLabel = t(intlMessages.seeMap);

  // If the map is not returned, which may occur because of an unauthorized map resource
  // associated to the page section, we just do not render the section.
  if (!map) return null;

  return (
    <PageSectionBlockWithTitleAndDescription
      title={title}
      description={description}
      iconClassName="icon-map-marker"
    >
      <div className="box box-image box-shadow-lg page-section-partipative-map-container">
        <div className="page-section-partipative-map-container-overlay">
          <ButtonLink
            className="btn btn-primary btn-md"
            href={mapPath}
            label={seeMapLabel}
            iconClassName="icon-arrow-right"
            iconPosition="after"
          />
        </div>

        <MapBase map={map} height={mapHeight} staticMap={true} zoomDefault={zoomDefault}>
          <>
            {isContributionsMap && isAuthorized(contributionsDisplayAuthorized) && (
              <ContributionsMapContributionsMarkersManager
                participativeModule={participativeModule}
              />
            )}

            {isUsersMap && <MapUsersPointsManager usersMapSlug={slug} />}
          </>
        </MapBase>
      </div>
    </PageSectionBlockWithTitleAndDescription>
  );
};

const PageSectionMap = props => {
  const pageSection = useFragment(PageSectionMap_pageSection, props.pageSection);
  const { map } = pageSection;

  return (
    <MapContextProvider map={map}>
      {/* Note that we provide the `pageSection` object that already resolved from the 
          PageSectionMap_pageSection fragment here, as the sub-component is in the same 
          file, which avoids having a separate fragment that we would resolve in the 
          PageSectionMapInner sub component
      */}
      <PageSectionMapInner {...props} pageSection={pageSection} />
    </MapContextProvider>
  );
};

const PageSectionMap_pageSection = graphql__cde694468780d29cfb12;

export default PageSectionMap;

const intlMessages = defineMessages({
  seeMap: {
    id: "pageSection.participativeMap.seeMap",
    defaultMessage: "Voir la carte"
  }
});
